import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ConfirmDeleteEventModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ConfirmDeleteEventModal extends Component {
	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isConfirmDeleteEventOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleConfirmDeleteEvent}>{strings.title}</ModalHeader>
		          	<ModalBody>
		            	{this.props.modalDescription}
		          	</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleConfirmDeleteEvent}
		            		>{strings.cancel}</button>
                        <button 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmConfirmDeleteEvent}
		            		>{this.props.modalButton}</button>    
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

ConfirmDeleteEventModal.propTypes = {
    modalDescription: PropTypes.string,
    modalButton: PropTypes.string,
    isConfirmDeleteEventOpen: PropTypes.bool,
    toggleConfirmDeleteEvent: PropTypes.func
}

export default ConfirmDeleteEventModal;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/ConfirmDeleteEventModal/ConfirmDeleteEventModal.js